import { useMemo } from 'react';
import { App, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';
import { useThemeToken } from '@/hooks';
import { DeviceWrapper } from '@/components';
import { FaceEnrollment } from '@/components/face';
import { useAppContext, useUniversityContext, useUserContext } from '@/context';
import Navbar from './Navbar';
import FeatureList from './Food/FeatureList';
import HelpdeskMode from './HelpdeskMode';
import DormitoryMode from './DormitoryMode';
import ReservableMode from './ReservableMode';
import CreditIncrement from './Food/CreditIncrement';
import AnnouncementsList from './Food/AnnouncementsList';
import { featureList } from './featureListData';
import SurveyMode from './SurveyMode';

import './Home.css';

export function HomePage() {
  const theme = useThemeToken();
  const [t] = useTranslation(['common']);
  const { mode } = useAppContext();
  const { university } = useUniversityContext();
  const { profile, roles } = useUserContext();

  const renderSwiperFeatures = () => {
    switch (mode) {
      case 'nurture':
        return <ReservableMode variant="nurture" />;
      case 'dormitory':
        return <DormitoryMode />;
      case 'sport':
        return <ReservableMode variant="sport" />;
      case 'health':
        return <ReservableMode variant="health" />;
      case 'transport':
        return <ReservableMode variant="transport" />;
      case 'helpdesk':
        return <HelpdeskMode />;
      case 'face':
        return <FaceEnrollment />;
      case 'survey':
        return <SurveyMode />;
      default:
        return <div>Module not found</div>;
    }
  };

  const { message } = App.useApp();
  const featureListMemo = useMemo(() => featureList(university, profile, roles, message, t)[mode], [mode, university, profile]);
  const isExpand = mode === 'face';
  const isDormitory = mode === 'dormitory';

  return (
    <>
      <DeviceWrapper show={['desktop']}>
        <Row className="w-full h-full">
          <Col span={isExpand ? 24 : 10} className="!flex !items-center">
            {renderSwiperFeatures()}
          </Col>
          {!isExpand &&
            <>
              <Col span={14} className="!flex !items-center">
                <Row
                  className="px-8 h-full w-full"
                  style={{ paddingTop: '2rem', paddingBottom: '2rem' }}
                >
                  <Col span={24}>
                    <FeatureList
                      features={featureListMemo}
                      color={theme.colorTextOverPrimary}
                    />
                  </Col>
                  <Col span={24} className="mt-auto">
                    {
                      !isDormitory &&
                      !envConfig.ui.removeWallet &&
                      (profile?.group == null || !profile?.group?.onlineCreditChargeForbidden) &&
                      <CreditIncrement />
                    }
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="mt-auto">
                <Row>
                  <Col span={24} className="!flex !flex-col">
                    <AnnouncementsList />
                  </Col>
                </Row>
              </Col>
            </>
          }
        </Row>
      </DeviceWrapper>
      <DeviceWrapper show={['mobile']}>
        <Row className="flex flex-lg-column home-body-container overflow-hidden">
          <Navbar />
          <Col
            span={19}
            lg={22}
            className="!flex mx-auto lg:mx-0 flex-col px-3 overflow-auto"
          >
            <div className="flex flex-col items-center max-h-full flex-1">
              {renderSwiperFeatures()}
            </div>
          </Col>
        </Row>
      </DeviceWrapper>
    </>
  );
}

export default HomePage;
